export const CREATE_JOURNAL_VOUCHER_MULTY  = 'CREATE_JOURNAL_VOUCHER_MULTY';
export const GET_JOURNAL_VOUCHER_MULTY  = 'GET_JOURNAL_VOUCHER_MULTY';
export const GET_JOURNAL_VOUCHER_MULTY_PAGE  = 'GET_JOURNAL_VOUCHER_MULTY_PAGE';
export const JOURNAL_VOUCHER_MULTY_REQUEST  = 'JOURNAL_VOUCHER_MULTY_REQUEST';
export const DELETE_JOURNAL_VOUCHER_MULTY  = 'DELETE_JOURNAL_VOUCHER_MULTY';
export const UPDATE_JOURNAL_VOUCHER_MULTY  = 'UPDATE_JOURNAL_VOUCHER_MULTY';
export const JOURNAL_VOUCHER_MULTY_REQUEST_SUCCESS  = 'JOURNAL_VOUCHER_MULTY_REQUEST_SUCCESS';
export const JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE  = 'JOURNAL_VOUCHER_MULTY_REQUEST_FAILURE';